import type { OpDefData } from '@frontend/api';

import { notify } from 'utils/reduxUtils';

export interface OpDefSelectorState {
  hasInitiated: boolean;
  isLoading: boolean;
  opDefs: OpDefData[];
}

export const ACTION_TYPES = {
  FETCH_OP_DEFS_ERROR: 'common/opDefSelector/FETCH_OP_DEFS_ERROR',
  FETCH_OP_DEFS_REQUEST: 'common/opDefSelector/FETCH_OP_DEFS_REQUEST',
  FETCH_OP_DEFS_SUCCESS: 'common/opDefSelector/FETCH_OP_DEFS_SUCCESS',
} as const;

export type OpDefSelectorActionTypes =
  (typeof ACTION_TYPES)[keyof typeof ACTION_TYPES];

interface FetchOpDefsRequestAction {
  type: typeof ACTION_TYPES.FETCH_OP_DEFS_REQUEST;
}

interface FetchOpDefsSuccessAction {
  type: typeof ACTION_TYPES.FETCH_OP_DEFS_SUCCESS;
  payload: { opDefs: OpDefData[] };
}

interface FetchOpDefsErrorAction {
  type: typeof ACTION_TYPES.FETCH_OP_DEFS_ERROR;
  payload: Error;
}

export type OpDefSelectorAction =
  | FetchOpDefsRequestAction
  | FetchOpDefsSuccessAction
  | FetchOpDefsErrorAction;

export const fetchOpDefs = {
  request: (): FetchOpDefsRequestAction => ({
    type: ACTION_TYPES.FETCH_OP_DEFS_REQUEST,
  }),
  success: ({ opDefs }: { opDefs: OpDefData[] }): FetchOpDefsSuccessAction => ({
    type: ACTION_TYPES.FETCH_OP_DEFS_SUCCESS,
    payload: { opDefs },
  }),
  error: notify(
    (error: Error): FetchOpDefsErrorAction => ({
      type: ACTION_TYPES.FETCH_OP_DEFS_ERROR,
      payload: error,
    }),
    "Can't fetch operations",
  ),
};
